export default __webpack_public_path__ + "static/dale-grant-b86cea5d46e4cf55cb6a1df4c4c6ea23.png";